import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import type { IntlService } from 'ember-intl';
import AlertBanner from 'tio-ui/components/alert-banner';
import Button from 'tio-ui/components/button';
import BetaHomeVerifyPhoneModal from 'tio-employee/components/beta/home/verify-phone-modal';
import { phoneCaptureCard } from 'tio-employee/utils/beta/phone-capture-card';
import type FeaturesService from 'tio-common/services/features';
import type SessionContextService from 'tio-employee/services/session-context';

/** The current dashboard's mobile-number ask, gated like the new dashboard's attention row. */
export default class DashboardPhoneCaptureAlert extends Component {
  @service declare features: FeaturesService;
  @service declare intl: IntlService;
  @service declare sessionContext: SessionContextService;

  @tracked isVerifying = false;

  get ask() {
    const state = this.sessionContext.currentEmployee?.phoneVerificationState ?? 'none';
    if (state === 'verified' || !this.features.can('phoneCapture.surfaces.postLoginOverlay')) {
      return undefined;
    }

    return phoneCaptureCard(this.intl, state);
  }

  openFlow = () => {
    this.isVerifying = true;
  };

  closeFlow = () => {
    this.isVerifying = false;
  };

  <template>
    {{#if this.ask}}
      <AlertBanner
        @intent="info"
        @title={{this.ask.title}}
        @live={{false}}
        aria-label={{this.ask.title}}
        data-test-dashboard-phone-capture-alert={{this.ask.state}}
      >
        <:default>{{this.ask.description}}</:default>
        <:action>
          <Button
            @intent="primary"
            @size="sm"
            @testHook="dashboard__add-mobile-number"
            {{on "click" this.openFlow}}
            data-test-dashboard-phone-capture-alert-action
          >
            {{this.ask.cta}}
          </Button>
        </:action>
      </AlertBanner>
    {{/if}}
    <BetaHomeVerifyPhoneModal
      @isOpen={{this.isVerifying}}
      @onClose={{this.closeFlow}}
      @employee={{this.sessionContext.currentEmployee}}
    />
  </template>
}
